module.exports = __webpack_public_path__ + "static/media/example-1.e50474e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BushfireFront/example-1.jpg
// module id = 197
// module chunks = 0